import {
  ReservationFlowSelectedPaymentMethodPrepaymentWithStripe,
  ReservationFlowSelectedPaymentMethodCreditCardHoldingNewCreditCardInfo,
  ReservationFlowSelectedPaymentMethodNewCreditCard,
} from '../interfaces/reservation_flow';

type PaymentMethodContext = {
  stripeConfirmationTokenId?: string;
  // isStoreCreditCardのデフォ値を決定するために使う値
  // 月謝は保存するか選択できない経路があるため、デフォでは保存する
  productType: 'subscription' | 'ticket_book';
};

export const convertPaymentMethodForSubmission = (
  paymentMethod:
    | ReservationFlowSelectedPaymentMethodCreditCardHoldingNewCreditCardInfo
    | ReservationFlowSelectedPaymentMethodNewCreditCard,
  context: PaymentMethodContext,
): ReservationFlowSelectedPaymentMethodPrepaymentWithStripe => {
  // TODO: [3ds] legacy対応終えるタイミングで、
  // ReservationFlowSelectedPaymentMethod にinputの型を流用してるの自体やめたい
  if (paymentMethod.type === 'credit_card') {
    return {
      type: 'prepayment_with_stripe',
      confirmation_token: null,
      use_last_used: true,
      save_as_last_used: false,
    };
  }

  if (typeof context.stripeConfirmationTokenId === 'undefined') {
    throw new Error('stripeConfirmationTokenId is required');
  }

  return {
    type: 'prepayment_with_stripe',
    confirmation_token: context.stripeConfirmationTokenId,
    use_last_used: false,
    save_as_last_used:
      paymentMethod.isStoreCreditCard ?? context.productType === 'subscription',
  };
};

export const isStripeSpecificError = (
  error: unknown,
): error is stripe.StripeError => {
  return (
    typeof error === 'object' &&
    error !== null &&
    'code' in (error as stripe.StripeError) &&
    'type' in (error as stripe.StripeError) &&
    'message' in (error as stripe.StripeError)
  );
};
